import React, { ReactNode } from "react";

interface MFASetupStepProps {
  children: ReactNode;
  stepNumber: number;
  title: string;
}

export default class MFASetupStep extends React.Component<MFASetupStepProps> {
  render(): JSX.Element {
    return (
      <div className="mfa-setup-step">
        <span className="mfa-setup-step__number">{this.props.stepNumber}</span>
        <div className="mfa-setup-step__content">
          <h5 className="mfa-setup-step__title">{this.props.title}</h5>
          {this.props.children}
        </div>
      </div>
    );
  }
}
